import {Controller} from "stimulus"

/**
 * Shows the import mode selector (overwrite/append/skip) when a file
 * is selected on the position description edit form.
 *
 * Usage:
 *   <form data-controller="import-mode">
 *     <input type="file" data-action="change->import-mode#fileSelected"
 *            data-target="import-mode.fileInput">
 *     <div data-target="import-mode.modeSelector" class="hidden">
 *       ...radio buttons...
 *     </div>
 *   </form>
 */
export default class extends Controller {
  static targets = ["fileInput", "modeSelector"]

  fileSelected() {
    if (!this.hasModeSelectorTarget) return

    if (this.fileInputTarget.files.length > 0) {
      this.modeSelectorTarget.classList.remove("hidden")
    } else {
      this.modeSelectorTarget.classList.add("hidden")
    }
  }
}
